import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  IconButton,
  InputProps,
  TextField,
  Tooltip,
} from "@mui/material";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 20,
});

function renderRow(props) {
  const { data, index, parent, style } = props;
  const option = data[index];

  return (
    <CellMeasurer
      cache={cache}
      columnIndex={0}
      key={index}
      parent={parent}
      rowIndex={index}
    >
      {({ registerChild }) => (
        <div ref={registerChild} style={style}>
          {option.label}
        </div>
      )}
    </CellMeasurer>
  );
}
type SearchMultiSelectProps = {
  items?: string[];
  setSelectedItems: (items: string[]) => void;
  selectedItems: string[];
  title: string;
  placeholderStr: string;
  tooltipContent?: string;
  isSingleSelect?: boolean;
  style?: React.CSSProperties;
  InputProps?: InputProps;
  textValue?: string;
  onChangeText?: (text: string) => void;
  AutocompleteProps?: any;
};

export default function SearchMultiSelect({
  items,
  setSelectedItems,
  selectedItems,
  title,
  placeholderStr,
  tooltipContent,
  isSingleSelect = false,
  style,
  InputProps,
  textValue,
  onChangeText,
  AutocompleteProps,
  ...rest
}: SearchMultiSelectProps) {
  function handleChange(_: any, value: string[]) {
    setSelectedItems(isSingleSelect ? value.slice(-1) : value);
  }
  const options = items ?? [];
  return (
    <FormControl fullWidth {...{ style }} {...rest}>
      <div className="textFieldLabel">
        {title}
        {tooltipContent && (
          <Tooltip title={tooltipContent}>
            <IconButton>
              <HelpCenterIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <Autocomplete
        // Overriding button styles to match regular select box drop down
        sx={{
          "& .MuiAutocomplete-popupIndicator": {
            "& :hover": {
              backgroundColor: "white",
            },
          },
          "& .MuiAutocomplete-popupIndicator, .MuiAutocomplete-popupIndicatorOpen":
            {
              transition: "none",
            },
          button: {
            padding: "2px 0 0 0",
          },
        }}
        className="autocomplete"
        multiple
        size="small"
        limitTags={2}
        options={options}
        getOptionLabel={option => option}
        value={selectedItems}
        onChange={handleChange}
        disableCloseOnSelect={true}
        autoHighlight={true}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <>
              <Checkbox
                icon={
                  isSingleSelect ? (
                    <RadioButtonUnchecked />
                  ) : (
                    <CheckBoxOutlineBlankIcon />
                  )
                }
                checkedIcon={
                  isSingleSelect ? <RadioButtonChecked /> : <CheckBoxIcon />
                }
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </>
          </li>
        )}
        renderInput={params => (
          <TextField
            {...params}
            // value={textValue}
            {...(onChangeText
              ? { onChange: e => onChangeText(e.target.value) }
              : {})}
            variant="outlined"
            placeholder={
              selectedItems.length === 0 ? placeholderStr : undefined
            }
            InputProps={InputProps}
          />
        )}
        renderListbox={props => (
          <div ref={props.ref}>
            <AutoSizer>
              {({ height, width }) => (
                <List
                  height={height}
                  width={width}
                  rowHeight={cache.rowHeight}
                  deferredMeasurementCache={cache}
                  rowCount={options.length}
                  rowRenderer={renderRow}
                  overscanRowCount={3}
                  {...props}
                />
              )}
            </AutoSizer>
          </div>
        )}
        {...AutocompleteProps}
      />
    </FormControl>
  );
}
